import React from 'react';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';

const Jobs = () => (
  <div className="jobs">
    <Meta
      title="Jobs"
      meta={[
        { name: 'robots', content: 'index,follow' },
        { name: 'description', content: 'Jobs currently open at crowdspring. Apply today!' },
        { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' }
      ]}
      link={[{ rel: 'canonical', href: getCanonicalURL('/jobs/') }]}
    />
    <div className="row">
      <div className="columns small-16 large-12">
        <h2>Help us change how the world buys creative services.</h2>
        <p>We&apos;re changing the way entrepreneurs, startups, established companies, agencies and non-profits around the world buy graphic design, web design, print design, product design, and naming services. Over 220,000 designers and namers from 195 countries have worked with us.</p>
        <p>We launched in 2008, re-launched a brand new site in 2017, and are now working to make crowdspring even better by reimagining everything about our business and our industry. This is an amazing opportunity for someone. We have big plans, but we can&apos;t do it alone.</p>
        <p>We&apos;re looking for incredibly smart, extraordinarily interesting people and we&apos;re highly protective of our culture. This can be a pretty tough place to get into. If you’re used to a corporate environment, you will not be happy here. We’re looking for someone who is tired of building things for other people and wants to be part of building a company. If you've got the smarts and the creativity (and you don't plan on showing up to the interview in a suit), we’d love to hear from you.</p>

        <h4>Open Roles</h4>
        <p><a href="https://crowdspring.workable.com/jobs/979835" target="_blank">Customer Support Superhero (full-time or part-time)</a></p>
      </div>
    </div>
  </div>
);

export default Jobs;



// WEBPACK FOOTER //
// ./marketing/about/jobs.jsx